/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CriteriaFinanceReport } from '../../models/criteria-finance-report';
import { EtaxReport } from '../../models/etax-report';

export interface ApiReportGetETaxReportPost$Params {
      body?: CriteriaFinanceReport
}

export function apiReportGetETaxReportPost(http: HttpClient, rootUrl: string, params?: ApiReportGetETaxReportPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<EtaxReport>>> {
  const rb = new RequestBuilder(rootUrl, apiReportGetETaxReportPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<EtaxReport>>;
    })
  );
}

apiReportGetETaxReportPost.PATH = '/api/Report/GetETaxReport';
